import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { Link } from 'gatsby';
import React from 'react';
import { useLayoutContext } from '../../contexts';

export const Breadcrumbs = () => {
  const { breadcrumbs } = useLayoutContext();

  if (!breadcrumbs) {
    return null;
  }

  return (
    <nav
      data-testid="breadcrumb"
      className="hidden mb-0 sm:flex"
      aria-label="Breadcrumb"
    >
      <div className="flex flex-row items-center space-x-4 cursor-pointer">
        {breadcrumbs.map(({ to, label }, i) => {
          const breadcrumbStyle =
            i === breadcrumbs.length - 1
              ? 'breadcrumb-item active'
              : 'breadcrumb-item';
          return (
            <React.Fragment key={`breadcrumb--${label}--${i}`}>
              {i !== 0 && (
                <ChevronRightIcon
                  className="flex-shrink-0 w-5 h-5 text-gray-400"
                  aria-hidden="true"
                  key={`icon--${i}`}
                />
              )}
              <Link to={to} className={breadcrumbStyle} key={label}>
                {label}
              </Link>
            </React.Fragment>
          );
        })}
      </div>
    </nav>
  );
};
